import { KeyboardEvent, useState, useEffect } from "react";
import {
  Flex,
  Switch,
  Text,
  FormControl,
  Box,
} from "@chakra-ui/react";
import { Input as InputBarte } from "barte-design-system";

interface InputProps {
  name: string;
  switchActive?: boolean;
  periodicityName?: string;
  containerDisabled?: boolean;
  hasMonthlyValue?: boolean;
  valueData?: any;
  asSubscription?: boolean;
  tooltipText?: string;
  hasSwitch?: boolean;
  label?: string;
  labelColor?: string;
  register?: any;
  setValue?: any;
  errors?: any;
  mask?: string;
  valueLenght?: number;
  classInput?: string;
  variant?: string;
  switchFunction?: (any?: any) => void;
  color?: string;
  asDoubleEffect?: boolean;
  optionalText?: string;
  icon?: React.ReactNode;
  className?: string;
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  [key: string]: any;
}

export function InputCurrency({
    name,
    setValue,
    switchActive,
    containerDisabled = true,
    periodicityName,
    valueLenght,
    hasMonthlyValue,
    valueData,
    asSubscription,
    tooltipText,
    label,
    labelColor = "gray.600",
    register,
    errors,
    mask,
    hasSwitch = false,
    classInput,
    variant,
    switchFunction,
    color,
    asDoubleEffect,
    optionalText,
    icon,
    className,
    placeholder,
    onChange,
    ...rest
  }: InputProps) {
  const [disabledState, setDisabledState] = useState(
    hasSwitch || containerDisabled
  );
  const [showCurrency, setShowCurrency] = useState(() => {
    const value = valueData || register?.value || rest?.value || rest?.defaultValue || '';
    return value.toString().replace(/\D/g, '') !== '';
  });

  const handleMaskInputCurrency = (e: KeyboardEvent<HTMLInputElement>) => {
    let { value } = e.currentTarget;
    let cleanValue = value.replace(/\D/g, '');
    if (cleanValue.length > 2) {
      cleanValue = cleanValue.replace(/(\d{2})$/, ',$1');
    }
    cleanValue = cleanValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    e.currentTarget.value = cleanValue
    setShowCurrency(cleanValue !== '');
    if (setValue) {
      setValue(name, e.currentTarget.value);
    }
    return e.currentTarget.value
  };

  function handleSwitchChange(e: any) {
    if (asDoubleEffect) {
      switchFunction(e);
    }
    setDisabledState(!disabledState);
    setValue ? setValue(name, null) : null;
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setShowCurrency(value.replace(/\D/g, '') !== '');
    
    if (onChange) {
      onChange(e);
    }
    if (register?.onChange) {
      register.onChange(e);
    }
  };

  const isDisabled = (hasSwitch && disabledState) || !containerDisabled || (asDoubleEffect && !switchActive);

  // Props que o InputBarte aceita
  const inputBarteProps: any = {
    type: "text",
    label: label,
    labelOptional: optionalText,
    helpText: tooltipText,
    placeholder: placeholder,
    error: errors?.message,
    icon: icon,
    className: classInput || className,
    disabled: isDisabled,
  };

  // Props do register e eventos que precisam ser passados para o input interno
  const inputEvents = {
    onKeyUp: handleMaskInputCurrency,
    name,
    onChange: handleChange,
    ...(register || {}),
  };

  useEffect(() => {
    setDisabledState(!switchActive);
  }, []);

  useEffect(() => {
    const currentValue = valueData || register?.value || rest?.value || '';
    setShowCurrency(currentValue.toString().replace(/\D/g, '') !== '');
  }, [valueData, register?.value, rest?.value]);

  return (
    <FormControl isInvalid={!!errors?.message}>
      <Flex flexDir="column">
        {(hasSwitch || tooltipText) && (
          <Flex align="center" w="332px" justify="space-between" mb=".2rem">
            {tooltipText && (
              <Text fontSize=".8rem" color="gray.500">
                {tooltipText}
              </Text>
            )}
            {hasSwitch && !asDoubleEffect && (
              <Switch
                name={name}
                defaultChecked={switchActive}
                onChange={handleSwitchChange}
                size="sm"
                colorScheme="cyan"
              />
            )}

            {hasSwitch && asDoubleEffect && (
              <Switch
                name={name}
                isChecked={switchActive}
                defaultChecked={switchActive}
                onChange={handleSwitchChange}
                size="sm"
                colorScheme="cyan"
              />
            )}
          </Flex>
        )}
        <Flex flexDir="column" position="relative">
          <Box position="relative" display="inline-block" width="100%">
            <InputBarte
              {...inputBarteProps}
              {...inputEvents}
              type="currency"
              style={{
                paddingLeft: showCurrency ? "20px" : undefined,
                ...rest?.style,
              }}
            />
            {showCurrency && (
              <Text
                fontSize={rest.fontSize || "14px"}
                position="relative"
                left="8px"
                top="-1.75rem"
                h="0"
                zIndex={3}
                color="black"
                pointerEvents="none"
              >
                R$
              </Text>
            )}
          </Box>
        </Flex>
      </Flex>
    </FormControl>
  );
}
